import { Link } from 'react-router-dom';

interface Props {
  /** The exact label of the button this notice sits next to, quoted verbatim
   *  so the copy always names the button the learner is about to click —
   *  "Start Now" on the catalogue cards (`ProgramsCatalogueBody`). */
  ctaLabel: string;
}

/**
 * The 18+/Terms/Privacy Policy notice shown above the catalogue grid on
 * `/programs` and the Learning "All Programs" tab (both render
 * `ProgramsCatalogueBody`). `GsaProgramDetail` has its own copy of this
 * notice rather than sharing this component - its design is unchanged from
 * before this one was redesigned to match Figma, and the two are free to
 * drift since product asked for them to look different.
 *
 * Styling matches Figma node 13505:95882: a bordered box with no fill
 * (border-secondary is the app's closest token to the design's #E5E7EB),
 * body copy in `tertiary` (the closest token to the design's #374151 -
 * `foreground` is near-black, `muted-foreground` too light), and `primary`
 * for the links (its HSL already matches the design's #1552D7). Font size
 * is one step down from the design's 18px/24px "Showcase" node - that node
 * renders larger than the notice actually looks on the live /programs page,
 * so 16px/24px is the corrected match.
 */
export const EnrollConsentNotice = ({ ctaLabel }: Props) => (
  <div className="rounded-lg border border-border-secondary px-6 py-4 text-base leading-6 text-tertiary">
    By clicking &quot;{ctaLabel}&quot;, you confirm that you&apos;re 18 or
    older and agree to our{' '}
    <Link
      to="https://www.frontiertech.edu/terms-of-use"
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary"
    >
      Terms
    </Link>{' '}
    and{' '}
    <Link
      to="https://frontiertech.edu/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary"
    >
      Privacy Policy
    </Link>
    .
  </div>
);
